import React from 'react';
// import heroPng from '../assets/main-hero.png';
import heroImage from "../assets/mobileDoctorImage.png"

const BannerImg = () => {
  return (
    <div className="lg:mt-20 md:mt-20">
      <img
        src={heroImage}
        className="w-full h-auto lg:max-h-[600px] md:max-h-[400px] sm:max-h-[300px] max-h-[300px] lg:w-[100%] md:w-[80%] sm:w-[70%] w-[230px] object-contain"
        alt=""
      />
    </div>
  );
};

export default BannerImg;
